import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { AdminService } from '../services/AdminService';

const AdminPortalPage = () => {
  const { user, accessToken, logout } = useAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('users');
  
  // New Student Provisioning State
  const [newStudent, setNewStudent] = useState({
    fullName: '',
    email: '',
    password: 'password123',
    programme: 'IELTS Academic Professional',
    studentClassification: 'INSTRUCTOR'
  });

  const navigate = useNavigate();

  useEffect(() => {
    const fetchAdminData = async () => {
      // Load from local registry or service
      const localUsers = JSON.parse(localStorage.getItem('llap_registered_users') || '[]');
      const defaultUsers = [
        { _id: '1', email: 'admin@llap.com', fullName: 'System Administrator', role: 'admin', accountStatus: 'ACTIVE' },
        { _id: '2', email: 'teacher@llap.com', fullName: 'Mrs. Shahd Abulila', role: 'teacher', accountStatus: 'ACTIVE' },
        { _id: '3', email: 'instructor.student@llap.com', fullName: 'Instructor Student Test', role: 'student', studentClassification: 'INSTRUCTOR', accountStatus: 'ACTIVE' },
        { _id: '4', email: 'student@llap.com', fullName: 'Public Student', role: 'student', studentClassification: 'PUBLIC', accountStatus: 'ACTIVE' }
      ];
      
      setUsers([...defaultUsers, ...localUsers]);
      setLoading(false);
    };

    fetchAdminData();
  }, [accessToken]);

  // Handle enrolling a new Instructor Student with personal info
  const handleEnrollStudent = (e) => {
    e.preventDefault();
    if (!newStudent.email || !newStudent.fullName) {
      alert('Please enter student name and email.');
      return;
    }

    const studentRecord = {
      _id: Date.now().toString(),
      fullName: newStudent.fullName,
      email: newStudent.email.trim().toLowerCase(),
      password: newStudent.password,
      role: 'student',
      studentClassification: newStudent.studentClassification,
      programme: newStudent.programme,
      supervisor: 'Mrs. Shahd Abulila',
      accountStatus: 'ACTIVE',
      createdAt: new Date().toISOString()
    };

    const registeredUsers = JSON.parse(localStorage.getItem('llap_registered_users') || '[]');
    registeredUsers.push(studentRecord);
    localStorage.setItem('llap_registered_users', JSON.stringify(registeredUsers));

    setUsers(prev => [...prev, studentRecord]);
    alert(`Successfully enrolled Instructor Student: ${newStudent.fullName} under Teacher Shahd!`);
    setNewStudent({ fullName: '', email: '', password: 'password123', programme: 'IELTS Academic Professional', studentClassification: 'INSTRUCTOR' });
  };

  const handleRoleChange = (targetUserId, newRole) => {
    setUsers(prev => prev.map(u => u._id === targetUserId ? { ...u, role: newRole } : u));
    alert('User role successfully updated!');
  };

  const handleClassificationChange = (targetUserId, newStudentType) => {
    setUsers(prev => prev.map(u => u._id === targetUserId ? { ...u, studentClassification: newStudentType } : u));
    alert('Student classification successfully updated!');
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  if (loading) {
    return <div style={{ padding: '40px', textAlign: 'center', fontFamily: 'Arial, sans-serif' }}><h2>Loading Administration Portal...</h2></div>;
  }

  return (
    <div style={{ padding: '40px', maxWidth: '1200px', margin: '0 auto', fontFamily: 'Arial, sans-serif' }}>
      <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '2px solid #eaeaea', paddingBottom: '20px', marginBottom: '30px' }}>
        <div>
          <h1 style={{ color: '#721c24', margin: '0 0 5px 0' }}>LLAP Academy — Administration Portal</h1>
          <p style={{ color: '#666', margin: 0 }}>Administrator: {user?.fullName || 'System Administrator'} (Least-Privilege Oversight)</p>
        </div>
        <button onClick={handleLogout} style={{ padding: '10px 20px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>
          Logout
        </button>
      </header>

      {/* Navigation Tabs */}
      <div style={{ display: 'flex', gap: '15px', marginBottom: '30px', borderBottom: '1px solid #ddd', paddingBottom: '10px' }}>
        <button onClick={() => setActiveTab('users')} style={{ padding: '10px 18px', background: activeTab === 'users' ? '#721c24' : '#fff', color: activeTab === 'users' ? '#fff' : '#333', border: '1px solid #ccc', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>User Administration</button>
        <button onClick={() => setActiveTab('monitoring')} style={{ padding: '10px 18px', background: activeTab === 'monitoring' ? '#721c24' : '#fff', color: activeTab === 'monitoring' ? '#fff' : '#333', border: '1px solid #ccc', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>System & Audit Monitoring</button>
      </div>

      {activeTab === 'users' ? (
        <div>
          {/* New Student Enrollment Section */}
          <section style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '30px' }}>
            <h3 style={{ marginTop: 0, color: '#0056b3' }}>Enroll New Instructor Student (Supervisor: Mrs. Shahd Abulila)</h3>
            <form onSubmit={handleEnrollStudent} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', marginBottom: '5px' }}>Full Name</label>
                <input type="text" value={newStudent.fullName} onChange={e => setNewStudent({...newStudent, fullName: e.target.value})} placeholder="e.g. Ahmad bin Ali" required style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', marginBottom: '5px' }}>Email Address</label>
                <input type="email" value={newStudent.email} onChange={e => setNewStudent({...newStudent, email: e.target.value})} placeholder="e.g. ahmad@llap.com" required style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', marginBottom: '5px' }}>Initial Password</label>
                <input type="text" value={newStudent.password} onChange={e => setNewStudent({...newStudent, password: e.target.value})} required style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', marginBottom: '5px' }}>Programme</label>
                <input type="text" value={newStudent.programme} onChange={e => setNewStudent({...newStudent, programme: e.target.value})} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }} />
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-end', gridColumn: 'span 2' }}>
                <button type="submit" style={{ padding: '9px 20px', background: '#28a745', color: '#fff', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer' }}>
                  Enroll Instructor Student
                </button>
              </div>
            </form>
          </section>

          {/* User Directory */}
          <div style={{ background: '#fff', padding: '25px', borderRadius: '8px', border: '1px solid #ddd' }}>
            <h2>Institutional User Directory & Role Administration</h2>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '15px', fontSize: '14px', textAlign: 'left' }}>
              <thead>
                <tr style={{ background: '#f8d7da', borderBottom: '2px solid #f5c6cb' }}>
                  <th style={{ padding: '10px' }}>Full Name</th>
                  <th style={{ padding: '10px' }}>Email</th>
                  <th style={{ padding: '10px' }}>Role</th>
                  <th style={{ padding: '10px' }}>Student Classification</th>
                  <th style={{ padding: '10px' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((u, idx) => (
                  <tr key={u._id || idx} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '10px' }}><strong>{u.fullName || 'N/A'}</strong></td>
                    <td style={{ padding: '10px' }}>{u.email}</td>
                    <td style={{ padding: '10px' }}>
                      <select value={u.role || 'student'} onChange={e => handleRoleChange(u._id, e.target.value)} style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}>
                        <option value="student">student</option>
                        <option value="teacher">teacher</option>
                        <option value="admin">admin</option>
                      </select>
                    </td>
                    <td style={{ padding: '10px' }}>
                      {u.role === 'student' ? (
                        <select value={u.studentClassification || 'PUBLIC'} onChange={e => handleClassificationChange(u._id, e.target.value)} style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}>
                          <option value="INSTRUCTOR">INSTRUCTOR</option>
                          <option value="PUBLIC">PUBLIC</option>
                        </select>
                      ) : (
                        <span style={{ color: '#888', fontSize: '12px' }}>N/A (Non-Student Staff)</span>
                      )}
                    </td>
                    <td style={{ padding: '10px' }}>
                      <span style={{ background: '#d4edda', color: '#155724', padding: '3px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold' }}>{u.accountStatus || 'Active'}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div style={{ background: '#fff', padding: '25px', borderRadius: '8px', border: '1px solid #ddd' }}>
          <h2>System Health & Audit Monitoring</h2>
          <p style={{ fontSize: '13px', color: '#666' }}>MongoDB Atlas and Mailgun services operational.</p>
        </div>
      )}
    </div>
  );
};

export default AdminPortalPage;